module.exports = __webpack_public_path__ + "static/img/beijing.1783910470864.png";